import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-492946b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = ["datetime"]
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["href", "target"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cross" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!
  const _component_Flex = _resolveComponent("Flex")!
  const _component_Separator = _resolveComponent("Separator")!
  const _component_Title = _resolveComponent("Title")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_component_Flex, { alignItems: "center" }, {
      default: _withCtx(() => [
        _createElementVNode("time", { datetime: _ctx.datetime }, [
          _createVNode(_component_Text, {
            value: _ctx.datetime?.toUpperCase(),
            size: "xsmall"
          }, null, 8, ["value"])
        ], 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.backendUrl + _ctx.icon,
            alt: ""
          }, null, 8, _hoisted_4)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Separator),
    _createVNode(_component_Title, {
      value: _ctx.title,
      tag: "h3",
      size: "small"
    }, null, 8, ["value"]),
    _createElementVNode("a", {
      href: _ctx.computedUrl,
      target: _ctx.url ? '_blank' : ''
    }, _hoisted_7, 8, _hoisted_5)
  ]))
}